import styled, { css } from 'styled-components';

const BaseInputStyles = css`
  display: block;
  width: 100%;
`;

const Input = styled.input`
  ${BaseInputStyles}
`;

const Select = styled.select`
  ${BaseInputStyles}
`;

const Label = styled.label`

`;

export { Input, Select, Label };